

export const contactUsData = [
  {
    id: 1,
    heading: '📬 General Inquiries',
    paragrafh: 'Have a question or need more info about our platform?',
    email: 'sales@spatialgrid.ai',
  },
  {
    id: 2,
    heading: '🤝 Partnerships & Collaboration',
    paragrafh:
      'Looking to collaborate on a project or integrate with our platform?',
    email: 'sales@spatialgrid.ai',
  },
  {
    id: 3,
    heading: '📰 Press & Media',
    paragrafh:
      'Interested in featuring Spatial Grid or speaking with our leadership team?',
    email: 'info@spatialgrid.ai',
  },
  {
    id: 4,
    heading: '🛡️ Security & Compliance',
    paragrafh: 'Have a question or need more info about our platform?',
    email: 'info@spatialgrid.ai',
  },
  {
    id: 5,
    heading: '🌐 Visit Us',
    paragrafh:
      '4th floor, Capital Tower, BZ Space, N Convention Rd, Surya Enclave, HITEC City, Hyderabad, Telangana 500084\nOr simply fill out the form below and our team will get back to you shortly.',
  },
];
